import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function ContextInterestedParties() {
  const { data, siteNames } = useHSE();
  const rows = data.contextIssues || data.context || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/context", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `ctx-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Total Context Issues" value={rows.length} testid="ctx-total" />
      <StatCard label="Internal Issues" value={rows.filter((r) => r.issueType === "internal").length} tone="info" />
      <StatCard label="External Issues" value={rows.filter((r) => r.issueType === "external").length} tone="warning" />
      <StatCard label="Active" value={rows.filter((r) => r.status !== "archived").length} tone="safe" />
    </div>
  );

  return (
    <RegisterPage
      title="Context & Interested Parties"
      subtitle="ISO 45001 / ISO 14001 Clause 4.1 & 4.2 — Internal/External Issues, Interested Parties & Compliance Obligations"
      storeKey="contextIssues"
      idPrefix="CTX"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "Issue ID" },
        { key: "issueType", label: "Scope", render: (r) => <span className="uppercase text-[10px] font-bold px-2 py-0.5 rounded bg-slate-100 text-slate-700">{r.issueType || "Internal"}</span> },
        { key: "category", label: "Category" },
        { key: "title", label: "Issue Title" },
        { key: "complianceObligation", label: "Compliance Obligation" },
        { key: "ownerUserId", label: "Owner" },
        { key: "reviewDate", label: "Review Date" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Issue ID" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "issueType", label: "Issue Scope", type: "select", options: ["internal", "external"] },
        { key: "category", label: "Category", type: "select", options: ["Governance", "Operational", "Environmental", "Social", "Legal", "Market"] },
        { key: "title", label: "Issue Title" },
        { key: "description", label: "Detailed Description", type: "textarea", full: true },
        { key: "impactDescription", label: "HSE / Business Impact", type: "textarea", full: true },
        { key: "complianceObligation", label: "Linked Compliance Obligation" },
        { key: "ownerUserId", label: "Owner" },
        { key: "reviewDate", label: "Next Review Date", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["active", "under_review", "archived"] },
      ]}
    />
  );
}
